const BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:3000";

export const getBaseUrl = () => BASE_URL;

export const routes = {
  auth: {
    login: `${BASE_URL}/m1/v1/auth/login`,
  },
  search: {
    patients: `${BASE_URL}/search`,
  },
  dashboard: {
    // User is derived from the auth token on the backend
    userDashboard: () => `${BASE_URL}/user-dashboard`,
    cardFavorite: (cardId: string) =>
      `${BASE_URL}/user-dashboard/cards/${cardId}/favorite`,
    getBannerNotifications: (memberId: string) =>
      `${BASE_URL}/banner-notification/${memberId}`,
    readBannerNotification: (bannerId: string) =>
      `${BASE_URL}/banner-notification/${bannerId}/status`,
  },
  cards: {
    demographics: `${BASE_URL}/demographics`,
    pcp: `${BASE_URL}/pcp`,
    healthplan: `${BASE_URL}/healthplan`,
    caremanagemnt: `${BASE_URL}/care-management`,
    behavioralHealth: `${BASE_URL}/behavioral-health-diagnoses`,
    adtAlerts: (memberId: string) => `${BASE_URL}/adt-alerts/${memberId}`,
    sdohBarriers: `${BASE_URL}/sdoh-barriers`,
    medicalDiagnoses: `${BASE_URL}/medical-diagnoses`,
    costUtilization: (memberId: string) =>
      `${BASE_URL}/cost-utilization/${memberId}`,
    referrals: (memberId: string) => `${BASE_URL}/referrals/${memberId}`,
    medicationFillHistory: (memberId: string) =>
      `${BASE_URL}/medication-fill-history/${memberId}`,
    immunizations: (memberId: string) =>
      `${BASE_URL}/immunizations/${memberId}`,
    careGaps: `${BASE_URL}/care-gaps`,
    riskStratification: (memberId: string) =>
      `${BASE_URL}/risk-stratification/${memberId}`,
    recentVisits: (memberId: string) => `${BASE_URL}/recent-visits/${memberId}`,
    drugClases: `${BASE_URL}/medication-fill-history/drug-classes`,
  },
  editLayout: {
    getAllCards: `${BASE_URL}/cards`,
    updateLayout: `${BASE_URL}/user-dashboard`,
    activeLayout: `${BASE_URL}/user-dashboard/active`,
    // Fetch a specific layout type without switching the active layout
    preferredLayout: `${BASE_URL}/user-dashboard?dashboardType=preferred`,
  },
};
